import NamedDto from 'modules/base/dto/NamedDto';

export default class SchedulingEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {boolean} */
		this.active = null;
		/** @type {number} */
		this.startTime = null;
		/** @type {number} */
		this.monitorTimeInSec = null;
		/** @type {number} */
		this.sleepTimeInSec = null;
		/** @type {number} */
		this.stopTime = null;
	}

	/**
	 * @typedef {Object} _SchedulingEditDtoProps
	 * @property {boolean} active
	 * @property {number} startTime
	 * @property {number} monitorTimeInSec
	 * @property {number} sleepTimeInSec
	 * @property {number} stopTime
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _SchedulingEditDtoProps} SchedulingEditDtoProps
	 */
	/**
	 *
	 * @param {SchedulingEditDtoProps} props
	 * @returns {SchedulingEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.active = props.active;
		this.startTime = props.startTime;
		this.monitorTimeInSec = props.monitorTimeInSec;
		this.sleepTimeInSec = props.sleepTimeInSec;
		this.stopTime = props.stopTime;
		return this;
	}
}
